import { useCallback } from "react";
import LinkCards from "src/components/shared/LinkCards/LinkCards";
import { useGetApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  setHasFetchedPerms,
  setIsRestrictedToOrg,
  setIsRestrictedToYacht,
  setPermsProperty,
} from "src/redux/slices/permsSlice";
import { PageContainer } from "src/styled";
import useIsFleet from "../../components/pages/Management/useIsFleet";
import { useNavigate } from "react-router-dom";

const Management = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { clientAdmin, yachtuser, management } = useSelector(
    state => state.permsSlice,
  );
  const mapManagement = useCallback(
    (data: any) => {
      if (
        // !clientAdmin &&
        yachtuser &&
        !management &&
        data?.data?.clientid !== "NULL" &&
        data?.data?.orgid !== "NULL" &&
        data?.data?.yachtid !== "NULL"
      ) {
        // restricted to yacht
        navigate(
          `/management/clients/organizations/${data.data.clientid}/yachts/${data.data.orgid}/yacht/${data.data.yachtid}`,
        );
        dispatch(setIsRestrictedToYacht(true));
      } else if (
        yachtuser &&
        !management &&
        data?.data?.clientid !== "NULL" &&
        data?.data?.orgid !== "NULL"
      ) {
        // restricted to organization
        navigate(
          `/management/clients/organizations/${data.data.clientid}/yachts/${data.data.orgid}`,
        );
        dispatch(setIsRestrictedToOrg(true));
      } else if (clientAdmin && data?.data?.clientid !== "NULL") {
        // restricted to client
        navigate(`/management/clients/organizations/${data.data.clientid}`);
      }

      // if (data?.redirect) {
      //   navigate("/" + data.redirect);
      // }
      dispatch(setHasFetchedPerms(true));
      dispatch(
        setPermsProperty({ key: "clientid", value: data?.data?.clientid }),
      );
      return data?.data?.content;
    },
    [dispatch],
  );

  const { data, isLoading } = useGetApi<any>({
    request: "get-management",
    mapper: mapManagement,
  });
  const fleetData = [
    {
      sect: "_yachts",
      name: "Yachts",
      desc: "Manage your fleet of yachts",
    },
    { sect: "_reports", name: "Reports", desc: "View and run reports" },
    { sect: "_reviews", name: "Reviews", desc: "View and manage reviews" },
    { sect: "_audits", name: "Audits", desc: "View and manage audits" },
    { sect: "_crew", name: "Crew Set Up", desc: "Manage your crew" },
    {
      sect: "_subscriptions",
      name: "Subscriptions",
      desc: "Manage your subscriptions",
    },
  ];

  const isFleet = useIsFleet();

  const tableData = isFleet ? fleetData : data;

  return (
    <PageContainer>
      <LinkCards
        content={tableData}
        loading={isLoading}
        pathPrefix="management"
      />
    </PageContainer>
  );
};

export default Management;
